"use strict";

var AccountFormHelper = require("../accountComponents/AccountFormHelper");

var ShipToAccountHelper = {
	initialize: function () {
		var account = this.getShippingAccountInfo();

		if (account && account.otherAddresses) {
			//Default if other address is the default shipping address
			var defaultShippingAddress = account.otherAddresses.find(address => address.isDefaultShipping);

			if (defaultShippingAddress) {
				//Click the radio button for other address
				var radioButton = $("[id='shipToAddressSelector_otherAddress']");
				$(radioButton).prop("checked", true);

				//Show the other addresses section
				var $otherAddressesComponent = $("[data-component='shipToOtherAddresses']");
				$otherAddressesComponent.removeClass("hidden");

				//Find the address that matched the default
				var $otherAddresses = $("[data-address-id]");
				$otherAddresses.each((index, element) => {
					if ($(element).attr("data-address-id") === defaultShippingAddress.id) {
						//Select the radio button
						var radioButton = $(element).find("input");
						radioButton.prop("checked", true);
					}
				});
			}
		}
	},

	getGiftAccountInfo: function () {
		// Gift account does not support demographic or media outlet so don't use AccountFormHelper.serializeDataNecessaryToCreateAnAccount
		var account = AccountFormHelper.serializeAddressForm("[data-component='createGiftAccountForm'] form", { shouldEncodePassword: false });

		if (!$.isEmptyObject(account)) {
			account.type = (account.organizationName || account.organizationType) ? "O" : "I";
			return account;
		}
		return null;
	},

	getAlternateShippingAddress: function () {
		var $existingAddressRadio = $("[data-component='otherAddresses.populated.singleAddress.view'] input[type='radio'][name='otherAddressesSelector']:checked");
		if ($existingAddressRadio.length) {
			var $populatedAddress = $existingAddressRadio.closest("[data-component='otherAddresses.populated.singleAddress']");
			var addressId = $populatedAddress.attr("data-address-id");
			//Might need to come up with a different way to set the shipping address so we do not have to rely upon the whole address being displayed
			//	Or, perhaps better, we allow the ID to be passed.
			return {
				address: {
					id: addressId
				}
			};
		}

		var $newAddressRadio = $("[data-component='otherAddresses.addForm'] input[type='radio'][name='otherAddressesSelector']:checked");
		if ($newAddressRadio.length) {
			var address = AccountFormHelper.serializeAddressForm("[data-component='otherAddresses.addForm'] form", { shouldEncodePassword: false });
			return address;
		}

		return {};
	},

	getShippingAddress: function () {
		return (this.getShippingAccountInfo() || {}).address || {};
	},

	getShippingAccountInfo: function (loggedInAccount) {
		var account = {};

		var shipAddressType = this.getShippingAddressType();
		switch (shipAddressType) {
			case "primary":
			case "other":
				account = loggedInAccount;
				if ($.isEmptyObject(account)) {
					account = (window.AccountActions && window.AccountActions.getLoggedInAccount()) || {}; // We use window.AccountActions here to prevent a circular dependency.

					if ($.isEmptyObject(account)) {
						account = AccountFormHelper.serializeCreateAccountFormOnly(/*shouldEncodePassword*/ false) || {};
					}
				}
				break;
			case "gift":
				account = AccountFormHelper.serializeAddressForm("[data-component='createGiftAccountForm'] form", { shouldEncodePassword: false }) || {};
				break;
			default:
				LoggerInstance.error(`Shipping address type ${shipAddressType} is not supported.`);
				break;
		}

		if (shipAddressType === "other") {
			// Clone the account object to avoid mutating the logged-in account
			account = Object.assign({}, account);
			account.address = (this.getAlternateShippingAddress() || {}).address || {};
		}

		return account;
	},

	getShippingAddressType: function () {
		var shipAddressType =
			$("[data-component='shipToAddressSelector'] input[type='radio'][name='shipToAddressSelector']:checked").val() ||
			"primary";

		return shipAddressType;
	}
};

module.exports = ShipToAccountHelper;